if (!customElements.get('glam-price-comparison')) {
  customElements.define('glam-price-comparison', class extends HTMLElement {
    connectedCallback() {
      this.checkFreshness = () => {
        const now = Date.now();
        const expires = Date.parse(this.dataset.expires);
        const checked = Date.parse(this.dataset.checked);
        this.hidden = !Number.isFinite(expires) || !Number.isFinite(checked) || checked > now || expires <= now || expires - checked > 259200000;
      };
      this.checkFreshness();
      this.freshnessTimer = setInterval(this.checkFreshness, 30000);
      document.addEventListener('visibilitychange', this.checkFreshness);
      window.addEventListener('pageshow', this.checkFreshness);
    }
    disconnectedCallback() {
      clearInterval(this.freshnessTimer);
      document.removeEventListener('visibilitychange', this.checkFreshness);
      window.removeEventListener('pageshow', this.checkFreshness);
    }
  });
}
